import React, {useState, useEffect, createContext} from 'react';
import {Helmet} from 'react-helmet';
import {
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {auth} from './firebase';
import NavBar from './components/NavBar';
import Login from './components/Login';
import Home from './components/Home';
import TelemedicineCharges from './components/Telemedicine/Charges';
import TelemedicineRelease from './components/Telemedicine/Release';
import TelemedicineReleases from './components/Telemedicine/Releases';
import TelemedicineReleasesPublic from './components/Telemedicine/ReleasesPublic';
import TelemedicineReleasesCreation from './components/Telemedicine/ReleasesCreation';
import TelemedicineReleasesRegisteredEmails from './components/Telemedicine/ReleasesRegisteredEmails';
import PACSCharges from './components/PACS/Charges';

const App = () => {
  const location = useLocation();
  const AuthenticationContext = createContext({});

  const [isAuthenticated, setIsAuthenticated] = useState<null | boolean>(null);

  auth.onAuthStateChanged((user) => {
    if (user) setIsAuthenticated(true);
    else setIsAuthenticated(false);
  });

  useEffect(() => {
    if (
      !isAuthenticated &&
      (location.pathname !== '/telemedicine/releases/public')
    ) {
      toast.error('Você precisa estar logado!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [isAuthenticated, location.pathname]);

  return (
    <AuthenticationContext.Provider
      value={{
        isAuthenticated,
      }}
    >
      <Helmet>
        <title>Administrativo Dr. TIS</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
      </Helmet>
      {
        isAuthenticated &&
        (location.pathname !== '/telemedicine/releases/public') &&
          <NavBar/>
      }
      <Routes>
        <Route path="/telemedicine/releases/public" element={<TelemedicineReleasesPublic />}/>
        {
          isAuthenticated ?
          <>
            <Route path="/" element={<Home />}/>
            <Route path="/home" element={<Home />}/>
            <Route path="/pacs/charges" element={<PACSCharges />}/>
            <Route path="/telemedicine/charges" element={<TelemedicineCharges />}/>
            <Route path="/telemedicine/releases" element={<TelemedicineReleases />}/>
            <Route path="/telemedicine/releases/:releaseId" element={<TelemedicineRelease />}/>
            <Route path="/telemedicine/releases/creation" element={<TelemedicineReleasesCreation />}/>
            <Route path="/telemedicine/releases/registeredEmails" element={<TelemedicineReleasesRegisteredEmails />}/>
          </> :
          <Route path="*" element={<Login />}/>
        }
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AuthenticationContext.Provider>
  );
};

export default App;
